import { BuilderState, DEFAULT_BUILDER_STATE } from './types';

const DRAFT_KEY = 'invoice_builder_draft';
const DRAFT_ENABLED_KEY = 'invoice_builder_draft_enabled';
const DOWNLOADS_KEY = 'invoice_builder_downloads';

export function loadDraft(): BuilderState | null {
  try {
    const raw = localStorage.getItem(DRAFT_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as BuilderState;
  } catch {
    return null;
  }
}

export function isDraftEnabled(): boolean {
  try {
    return localStorage.getItem(DRAFT_ENABLED_KEY) === 'true';
  } catch {
    return false;
  }
}

export function saveDraft(state: BuilderState) {
  try {
    localStorage.setItem(DRAFT_KEY, JSON.stringify(state));
    localStorage.setItem(DRAFT_ENABLED_KEY, 'true');
  } catch {
    // storage full or unavailable
  }
}

export function clearDraft() {
  try {
    localStorage.removeItem(DRAFT_KEY);
    localStorage.removeItem(DRAFT_ENABLED_KEY);
  } catch {
    // unavailable
  }
}

export function getDownloadCount(): number {
  try {
    return parseInt(localStorage.getItem(DOWNLOADS_KEY) ?? '0', 10);
  } catch {
    return 0;
  }
}

export function incrementDownloadCount() {
  try {
    const count = getDownloadCount();
    localStorage.setItem(DOWNLOADS_KEY, String(count + 1));
  } catch {
    // unavailable
  }
}

export { DEFAULT_BUILDER_STATE };
